(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-create-name.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-create-name.js');
'use strict';

const {
  Form,
  ControlGroup,
  Inputv2
} = svs.ui.reactForm;
const {
  ReactButton: Button
} = svs.ui;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  createTeamAsync
} = svs.arena.service.teamsService;
const {
  handleCreateTeamErrorResponseFromServer
} = svs.arena.pages.teams.errorHandlers;

const TeamsCreateName = _ref => {
  let {
    setCreatedTeamId
  } = _ref;
  const [teamName, setTeamName] = React.useState('');
  const [teamNameError, setTeamNameError] = React.useState(false);
  const [teamNameErrorMessage, setTeamNameErrorMessage] = React.useState('');
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
  const validate = curTeamName => {
    let isValid = true;
    if (curTeamName !== null && curTeamName !== void 0 && curTeamName.match(/([^A-Za-z0-9-_\sÅÄÖåäö])/g)) {
      setTeamNameErrorMessage('Namnet innehåller otillåtna tecken');
      setTeamNameError(true);
      isValid = false;
    } else if ((curTeamName === null || curTeamName === void 0 ? void 0 : curTeamName.length) > 31) {
      setTeamNameErrorMessage('Namnet är för långt');
      setTeamNameError(true);
      isValid = false;
    }
    return isValid;
  };
  const handleTeamNameChange = e => {
    e.preventDefault();
    setTeamName(e.target.value);
    if (teamNameError) {
      setTeamNameError(false);
      setTeamNameErrorMessage('');
    }
    validate(e.target.value);
    if (e.target.value && e.target.value.length > 0) {
      if (isButtonDisabled) {
        setIsButtonDisabled(false);
      }
    } else {
      setIsButtonDisabled(true);
    }
  };
  const submitForm = async e => {
    var _createResponse$data;
    e.preventDefault();
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    if (!validate(teamName)) {
      return;
    }
    const createResponse = await createTeamAsync({
      syndicateName: teamName
    });
    if (createResponse.error || !((_createResponse$data = createResponse.data) !== null && _createResponse$data !== void 0 && _createResponse$data.syndicateId)) {
      var _createResponse$error;
      svs.arena.logger.debug('*** submitForm createTeamAsync, createResponse.error ', createResponse.error);
      if (((_createResponse$error = createResponse.error) === null || _createResponse$error === void 0 ? void 0 : _createResponse$error.code) === '22 115') {
        setTeamNameErrorMessage('Detta namn är tyvärr redan upptaget');
      }
      handleCreateTeamErrorResponseFromServer(createResponse.error, teamName, setTeamNameError);
      return;
    }
    const track = {
      category: 'spela-tillsammans',
      action: 'new_team',
      opt_label: 'create_team'
    };
    svs.components.analytics.trackEvent(track);
    setCreatedTeamId(createResponse.data.syndicateId);
  };
  return React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(WidgetArea, {
    areaName: "arenaCreateTeamPageHero",
    fallback: React.createElement("div", {
      className: "margin-2 align-center h2"
    }, "V\xE4lj lagnamn och bjud in v\xE4nner!")
  }), React.createElement("div", {
    className: "margin-top-1 f-center"
  }, "N\xE4r du spelar tillsammans med andra h\xE5ller ni den gemensamma dr\xF6mmen vid liv. Och det b\xE4sta med dr\xF6mmar \xE4r att de kan g\xE5 i uppfyllelse."), React.createElement(Form, {
    id: "create-team-form",
    method: "POST",
    onSubmit: submitForm
  }, React.createElement(ControlGroup, {
    errorMessage: teamNameErrorMessage,
    hasError: teamNameError,
    infoMessage: "Till\xE5tna tecken f\xF6r lagnamnet \xE4r bokst\xE4ver, siffror, bindestreck och understreck. Maximalt antal tecken \xE4r 31.",
    v2: true
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "teamName",
    label: "Hitta p\xE5 ett namn f\xF6r ditt nya lag",
    onChange: handleTeamNameChange,
    type: "text",
    value: teamName
  })), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isButtonDisabled,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Skapa lag")));
};
svs.arena.pages.teams.components.TeamsCreateName = TeamsCreateName;

 })(window);